import * as React from "react";
import styled from "styled-components";
import { Button, MenuItem } from "components/bootstrap";
import { Icon } from "components/common";
import { DropdownMenu } from "security-app/components/common";
import { ColumnToggler } from "security-app/components/common/ColumnToggler";
import { usePagination, useSetPagination } from "common/contexts";
import BulkActions from "./BulkActions";
import AssetTabs from "./AssetTypeTabs";
const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;
const LeftActions = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 1rem;
`;
const RightActions = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: 1rem;
`;
const TabsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 7px;
  padding: 7px;
  background-color: ${({ theme }) => theme.colors.global.background};
  border-radius: 6px;
`;
const SelectContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.6rem;
`;
const IconContainer = styled.div`
  width: 16px;
  display: inline-block;
  text-align: left;
`;
const PAGE_SIZES = [
  { label: "10", value: "10" },
  { label: "20", value: "20" },
  { label: "50", value: "50" },
  { label: "100", value: "100" }
];
function ListActionsSUI({ assetType }) {
  const localPagination = usePagination();
  const setLocalPagination = useSetPagination();
  const onPageSizeChange = (newPage, newPageSize) => {
    setLocalPagination({ ...localPagination, page: newPage, perPage: newPageSize });
  };
  return /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(LeftActions, null, /* @__PURE__ */ React.createElement(BulkActions, null), /* @__PURE__ */ React.createElement(TabsContainer, null, /* @__PURE__ */ React.createElement(AssetTabs, { assetType }))), /* @__PURE__ */ React.createElement(RightActions, null, /* @__PURE__ */ React.createElement(ColumnToggler, null), /* @__PURE__ */ React.createElement(SelectContainer, { role: "list", "aria-label": "Page Size" }, /* @__PURE__ */ React.createElement("small", { className: "text-muted" }, "Show"), /* @__PURE__ */ React.createElement(
    DropdownMenu,
    {
      trigger: /* @__PURE__ */ React.createElement(Button, { bsSize: "small" }, /* @__PURE__ */ React.createElement(IconContainer, null, /* @__PURE__ */ React.createElement(Icon, { name: "arrow_drop_down", size: "xs" })), localPagination.perPage)
    },
    PAGE_SIZES.map((size) => /* @__PURE__ */ React.createElement(MenuItem, { key: size.value, onClick: () => onPageSizeChange(1, parseInt(size.value, 10)) }, size.label))
  ))));
}
export default ListActionsSUI;
